// Route a freshly-created business to its social-connections page so the client
// can connect their networks first. Uses the business's connect_token (the
// shareable link the /social-connections/:token route resolves). Falls back to
// the business-scoped connections page, then the dashboard.
export function connectionsPathFor(business) {
  if (business?.connect_token) return `/social-connections/${business.connect_token}`;
  return '/social-connections';
}

export default connectionsPathFor;
